var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'text-section': true,..._vm.classes}},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"text-content"},[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }